import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsTabPanel from "./en-us/tabpanel.json";
import localizationEnUsTableCanceled from "./en-us/table-canceled.json";
import localizationEnUsTableInstalled from "./en-us/table-installed.json";
import localizationEnUsTableToInstall from "./en-us/table-to-install.json";

export const localizationEnUsHardware = {
  ...localizationEnUsHeader,
  ...localizationEnUsTabPanel,
  ...localizationEnUsTableCanceled,
  ...localizationEnUsTableInstalled,
  ...localizationEnUsTableToInstall,
};
